import React from "react";
import {withGoogleMap, GoogleMap, Marker, Polyline} from "react-google-maps/lib";
import mapStyle from "./map_component_style";
import './map_component.less';

const MapComponent = withGoogleMap((props, idx) => (
  <GoogleMap
    defaultZoom={8}
    center={{lat: props.lat, lng: props.lng}}
    defaultOptions={{ styles: mapStyle }}>

    {props.markers.map((marker, key) => (
      <Marker
        {...marker}
        key = {key}
        onRightClick={() => props.onMarkerRightClick(marker)}
        onClick = {(marker) => {props.getMarkerCallback(marker)}}
      />
    ))}
  </GoogleMap>
));

export default class Map extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      markers : [
        {
          position: {
            lat:  23.885942,     //default Saudi Arabia lat and long if browser doesnot get current location
            lng: 45.079162,
          },
          icon: '../../public/images/icons_png/location_pin.png',
          defaultAnimation: 2
        }
      ],
      lat : 23.885942,
      lng : 45.079162
    }
  }
  componentDidMount(){
    const self = this;
    if(this.props.lat && this.props.lng)
    {
      this.setCurrentLocation(this.props.lat , this.props.lng)
    }else{
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function(position){
          let currentLat = position.coords.latitude;
          let currnetLng = position.coords.longitude;
          self.setCurrentLocation(currentLat,currnetLng )
        }, function(){
          console.log("failed");
        });
      }
    }
  }
  componentWillReceiveProps(props){
    let newProps = Object.assign({}, props);
    if(newProps.lat == 0 && newProps.lng == 0){
        newProps.lat = 23.885942;
        newProps.lng = 45.079162;
      }
    this.setCurrentLocation(newProps.lat ? newProps.lat: this.state.lat, newProps.lng ? newProps.lng: this.state.lng)
  }
  setCurrentLocation = (currentLat, currnetLng) =>{
    let markers =[
      {
        position: {
          lat:  currentLat,
          lng: currnetLng
        },
        icon: '../../public/images/icons_png/location_pin.png',
        defaultAnimation: 2
      }
    ]
    this.setState({
      markers,
      lat : currentLat,
      lng : currnetLng
    })
  }
  render() {
    const {state ,props} = this;
    let mapClass;
    let markers;
    let defaultMarker = '../../public/images/icons_png/location_pin.png';
    let selectedMArker = '../../public/images/icons_png/location_pin_selected.png';
    let lat, lng;
    (props.mapClass) ? (mapClass = props.mapClass) : (mapClass="map-class");
    (props.markers) ? (markers = props.markers) : (markers = state.markers);
    // let markers;
    // (props.markers) ? (markers = props.markers) : (markers = state.markers);
    return (
      <div className={mapClass}>
        <MapComponent
          containerElement={<div className={mapClass} />}
          mapElement={<div className={mapClass} />}
          markers={markers}
          lat = {state.lat}
          lng = {state.lng}
          getMarkerCallback = {props.getMarkerCallback}
          />

      </div>
    );
  }
}



// WEBPACK FOOTER //
// app/components/map_component/map_component.jsx